<div class="h-full w-full flex flex-col min-h-0 overflow-hidden">
    <div class="p-4 flex flex-col gap-4 flex-1 min-h-0 overflow-y-auto">
        <div class="flex-shrink-0 flex flex-col gap-2">
            <p class="text-xs text-zinc-600 font-medium">Input</p>
            <div class="text-sm text-zinc-900 font-mono">{{ formattedAssistantContent() }}</div>
        </div>

        <div class="flex flex-col flex-1 gap-2 min-h-0 bg-zinc-50 rounded-lg p-3 h-auto max-h-full overflow-hidden">
            <p class="text-xs text-zinc-600 font-medium">Output</p>
            <div class="prose prose-sm max-w-none text-zinc-900 overflow-y-auto"
                [innerHTML]="formattedToolContent() | markdownRender"></div>

        </div>
    </div>
</div>
